import { IState } from '../types';
import { TAudioWordItem, TLemmaResult } from '../../../common/rest/words/wordsRest';
import { TAudioWordsState, TWordsNativeState } from './types';

export const getWordsNative = (state: IState, audioId: number): TWordsNativeState | undefined =>
	state.words.native[audioId];

// compared by values: generate keeps insertion key order, jsonb from the DB reorders keys
export const sameWords = (a: TAudioWordItem[], b: TAudioWordItem[]): boolean =>
	a === b || (a.length === b.length && a.every((w, i) => w.word === b[i].word && w.meaning === b[i].meaning));

// a translation (or a request for one) is only valid for the list it was made from — by content, since
// every tab open reloads the same list as a new array
export const isWordsNativeFor = (native: TWordsNativeState | undefined, words: TAudioWordItem[], langCode?: string): boolean =>
	!!native && native.langCode === langCode && sameWords(native.words, words);

export const getAudioWords = (state: IState, audioId: number): TAudioWordsState | undefined =>
	state.words.byAudioId[audioId];

export const isWordsGenerating = (state: IState, audioId: number): boolean =>
	!!state.words.generating[audioId];

const NO_LEMMAS: Record<string, TLemmaResult> = {};

export const getWordsLemmas = (state: IState, langCode?: string): Record<string, TLemmaResult> =>
	(langCode && state.words.lemmas[langCode]) || NO_LEMMAS;

export const isWordsLemmasLoading = (state: IState, langCode?: string): boolean =>
	!!langCode && (state.words.lemmasPending[langCode] || 0) > 0;

export const isWordsLoadFailed = (state: IState, audioId: number): boolean =>
	!!state.words.loadFailed[audioId];

export const isWordsGenerateFailed = (state: IState, audioId: number): boolean =>
	!!state.words.generateFailed[audioId];
